import { useCallback, useMemo } from 'react'
import type { LocationDescriptor } from 'history'
import { useHistory } from 'react-router'

interface AppNavigation {
  go(delta: number): void
  goBack(): void
  push(to: LocationDescriptor): void
  replace(to: LocationDescriptor): void
}

export function useAppNavigation(): AppNavigation {
  const history = useHistory()

  const go = useCallback((delta: number) => {
    history.go(delta)
  }, [history])

  const goBack = useCallback(() => {
    history.goBack()
  }, [history])

  const push = useCallback((to: LocationDescriptor) => {
    history.push(to)
  }, [history])

  const replace = useCallback((to: LocationDescriptor) => {
    history.replace(to)
  }, [history])

  return useMemo(() => ({
    go,
    goBack,
    push,
    replace,
  }), [go, goBack, push, replace])
}
